import { z } from 'zod';
import { OwnerSchema } from '../owner/owner.js';
import { WhiteLabelServiceEventBaseSchema, whiteLabelServiceEventType } from './service.js';
const ownerEventType = (eventName) => whiteLabelServiceEventType('owner', eventName);
const ownerEventMetadata = WhiteLabelServiceEventBaseSchema.shape.metadata.and(z.object({
    requestActor: z.string(),
}));
export const OwnerCreatedEventSchema = WhiteLabelServiceEventBaseSchema.extend({
    type: ownerEventType('created'),
    owner: OwnerSchema,
    metadata: ownerEventMetadata,
});
export const OwnerUpdatedEventSchema = WhiteLabelServiceEventBaseSchema.extend({
    type: ownerEventType('updated'),
    owner: OwnerSchema,
    metadata: ownerEventMetadata,
});
